"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrenciesQuery = void 0;
const react_query_1 = require("@tanstack/react-query");
const pino_1 = __importDefault(require("pino"));
const zod_1 = require("zod");
const paymentRepository_1 = require("../repositories/paymentRepository");
const teamRepository_1 = require("../repositories/teamRepository");
const query_keys_1 = require("./query-keys");
const logger = (0, pino_1.default)({ name: 'currenciesQuery' });
const CurrencySchema = zod_1.z.array(zod_1.z.enum(['GBP', 'USD']));
const getCurrencies = async (teamId) => {
    const currencies = await (teamId
        ? teamRepository_1.TeamRepository.getCurrencies(teamId)
        : paymentRepository_1.PaymentRepository.getCurrencies());
    const result = CurrencySchema.safeParse(currencies);
    if (!result.success) {
        logger.error('Validation for currencies failed', result.error);
        throw new Error('Validation for currencies failed');
    }
    return result.data;
};
const getCurrenciesQuery = (teamId) => {
    return (0, react_query_1.queryOptions)({ queryKey: query_keys_1.currenciesKeys.getCurrencies(teamId), queryFn: () => getCurrencies(teamId) });
};
exports.getCurrenciesQuery = getCurrenciesQuery;
